interface Props {
  categories: { id: string; name: string }[];
  regions: string[];
  selectedCategory: string;
  selectedRegion: string;
  selectedSort: string;
  onCategoryChange: (v: string) => void;
  onRegionChange: (v: string) => void;
  onSortChange: (v: string) => void;
  resultsCount: number;
}

export default function Filters({
  categories,
  regions,
  selectedCategory,
  selectedRegion,
  selectedSort,
  onCategoryChange,
  onRegionChange,
  onSortChange,
  resultsCount,
}: Props) {
  return (
    <div className="max-w-[1440px] mx-auto px-4 md:px-8 pb-5 flex flex-col gap-3">
      <div className="flex items-center justify-between gap-3">
        <span className="text-xs text-text-muted font-medium whitespace-nowrap">Filter:</span>
        <span className="ml-auto text-sm text-text-muted whitespace-nowrap">
          {resultsCount} {resultsCount === 1 ? 'result' : 'results'}
        </span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-3">
        <select
          value={selectedCategory}
          onChange={(e) => onCategoryChange(e.target.value)}
          className="px-3 py-2.5 bg-card-light dark:bg-card border border-[rgba(79,179,217,0.2)] dark:border-[rgba(79,179,217,0.25)] rounded-md text-text-primary-light dark:text-text-primary text-sm outline-none cursor-pointer hover:border-accent transition-colors w-full"
        >
          <option value="">All categories</option>
          {categories.map((c) => (
            <option key={c.id} value={c.id}>{c.name}</option>
          ))}
        </select>
        <select
          value={selectedRegion}
          onChange={(e) => onRegionChange(e.target.value)}
          className="px-3 py-2.5 bg-card-light dark:bg-card border border-[rgba(79,179,217,0.2)] dark:border-[rgba(79,179,217,0.25)] rounded-md text-text-primary-light dark:text-text-primary text-sm outline-none cursor-pointer hover:border-accent transition-colors w-full"
        >
          <option value="">All regions</option>
          {regions.map((r) => (
            <option key={r} value={r}>{r}</option>
          ))}
        </select>
        <select
          value={selectedSort}
          onChange={(e) => onSortChange(e.target.value)}
          className="px-3 py-2.5 bg-card-light dark:bg-card border border-[rgba(79,179,217,0.2)] dark:border-[rgba(79,179,217,0.25)] rounded-md text-text-primary-light dark:text-text-primary text-sm outline-none cursor-pointer hover:border-accent transition-colors w-full"
        >
          <option value="rating">Top rated</option>
          <option value="name">Name A-Z</option>
          <option value="reviews">Most reviewed</option>
        </select>
      </div>
    </div>
  );
}
